export default __webpack_public_path__ + "static/media/closet1-2048w.285301ce.webp";